import { render, staticRenderFns } from "./wisdom.vue?vue&type=template&id=7681f45b&scoped=true&"
import script from "./wisdom.vue?vue&type=script&lang=js&"
export * from "./wisdom.vue?vue&type=script&lang=js&"
import style0 from "./wisdom.vue?vue&type=style&index=0&id=7681f45b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7681f45b",
  null
  
)

export default component.exports